import * as React from "react";

export const SvgAdd = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M10 2c-4.411 0-8 3.589-8 8 0 4.412 3.589 8 8 8 4.412 0 8-3.59 8-8s-3.588-8-8-8Zm0 14.76A6.769 6.769 0 0 1 3.24 10 6.769 6.769 0 0 1 10 3.24 6.769 6.769 0 0 1 16.76 10 6.768 6.768 0 0 1 10 16.76Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.3}
		/>
		<path
			d="M13.099 9.324H10.62V6.846a.62.62 0 1 0-1.24 0v2.478H6.903a.62.62 0 1 0 0 1.24H9.38v2.479a.62.62 0 1 0 1.239 0v-2.48h2.479a.62.62 0 1 0 0-1.239Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.3}
		/>
	</svg>
);
